import { PageLayout, PageTitle } from "../components/PageLayout";

export default function Impressum() {
  return (
    <PageLayout>
      <PageTitle testId="page-impressum-title">Impressum</PageTitle>
      <div
        className="mx-auto mt-10 w-full max-w-3xl space-y-8 text-[16px] leading-[1.65] sm:text-[17px]"
        style={{ color: "#1A1A1A" }}
        data-testid="page-impressum-body"
      >
        <section>
          <p>
            Stephan Weiler<br />
            Stephan Weiler, agentur weiler<br />
            Baumgartenstraße 90<br />
            34130 Kassel
          </p>
        </section>

        <section>
          <h2
            className="text-[22px] sm:text-[24px]"
            style={{ color: "#1A1A1A", fontWeight: 600 }}
          >
            Kontakt
          </h2>
          <p className="mt-3">
            Telefon: 01709012068<br />
            E-Mail:{" "}
            <a
              href="mailto:info@outofthewronglife.com"
              className="underline transition-opacity duration-200 hover:opacity-70"
              style={{ color: "#1A1A1A" }}
            >
              info@outofthewronglife.com
            </a>
          </p>
        </section>

        <section>
          <h2
            className="text-[22px] sm:text-[24px]"
            style={{ color: "#1A1A1A", fontWeight: 600 }}
          >
            Umsatzsteuer-ID
          </h2>
          <p className="mt-3">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
            <br />
            DE204683541
          </p>
        </section>

        <section>
          <h2
            className="text-[22px] sm:text-[24px]"
            style={{ color: "#1A1A1A", fontWeight: 600 }}
          >
            Redaktionell verantwortlich
          </h2>
          <p className="mt-3">Stephan Weiler</p>
        </section>

        <section>
          <h2
            className="text-[22px] sm:text-[24px]"
            style={{ color: "#1A1A1A", fontWeight: 600 }}
          >
            Verbraucherstreitbeilegung / Universalschlichtungsstelle
          </h2>
          <p className="mt-3">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
            vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <p
          className="text-xs"
          style={{ color: "rgba(26,26,26,0.5)" }}
        >
          Quelle:{" "}
          <a
            href="https://www.e-recht24.de"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            e-recht24.de
          </a>
        </p>
      </div>
    </PageLayout>
  );
}
